module.exports = __webpack_public_path__ + "static/media/question.2d5f5368.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/question.svg
// module id = 521
// module chunks = 4